import React, { useState, useEffect } from 'react';

const MultiSelectDropdown = ({ label, options, selectedValues, onChange, placeholder }) => {
    const [search, setSearch] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const hasSelection = selectedValues.length > 0 || dropdownOpen;

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleCheckboxChange = (value) => {
        const newSelected = selectedValues.includes(value)
            ? selectedValues.filter((item) => item !== value)
            : [...selectedValues, value];
        onChange(newSelected);
    };

    const filteredOptions = options.filter((opt) =>
        opt.label.toLowerCase().includes(search.toLowerCase())
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.multi-select-dropdown')) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <div className="multi-select-dropdown relative w-full">
            {/* Floating Label */}
            <label
                className="absolute left-3 -top-3.5 bg-white px-1 text-sm text-gray-500 transition-all 
                peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 
                peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-blue-500"
            >
            
                {label}
            </label>

            {/* Selected Items Display */}
            <div
                className="border border-gray-300 rounded-lg p-2 cursor-pointer flex flex-wrap gap-2 min-h-[40px] focus-within:border-blue-500"
                onClick={toggleDropdown}
            >
                {selectedValues.length > 0 ? (
                    selectedValues.map((value) => {
                        const item = options.find((opt) => opt.value === value);
                        return (
                            <span
                                key={value}
                                className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-sm"
                            >
                                {item?.label}
                            </span>
                        );
                    })
                ) : (
                    <span className="text-gray-400">{placeholder}</span>
                )}
            </div>

            {/* Dropdown Options */}
            {dropdownOpen && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-full p-2 border-b border-gray-200 focus:outline-none"
                    />
                    <ul>
                        {filteredOptions.map((option) => (
                            <li
                                key={option.value}
                                className={`flex items-center p-2 hover:bg-gray-100 cursor-pointer ${
                                    selectedValues.includes(option.value) ? 'bg-blue-50' : ''
                                }`}
                                onClick={() => handleCheckboxChange(option.value)}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedValues.includes(option.value)}
                                    onChange={() => handleCheckboxChange(option.value)}
                                    className="mr-2"
                                />
                                <span
                                    className={`${
                                        selectedValues.includes(option.value)
                                            ? 'font-semibold text-blue-700'
                                            : ''
                                    }`}
                                >
                                    {option.label}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default MultiSelectDropdown;
